import React from 'react';
import { H3 } from '../../components/H3';

export default () => {
  return (
      <>
        <div className="-mx-8 bgcolorf5f5f5 md:-mt-10 mt-0 pt-12 flex flex-col items-center justify-center space-y-8 text-left pb-20">
          <H3 className="font-semibold text-16 pl-5 md:pl-0">쇼핑 정보</H3>
          <div className="max-w-3xl m-auto pt-3 p-5 pl-12">
            <div className="text-12 flex flex-col space-y-6">
              <p className="flex flex-col ">
                <p className="text-12 pb-10">
                  * 제품 혼용율에 따라 세탁 및 취급 유의 사항이 변경될 수 있으므로 반드시 부착되어 있는 케어라벨 내용을 확인하신 후 세탁하시기 바랍니다. 세탁 과실로 인하여 상품의 변형,이염,오염 등으로 상품에 문제가 발생 시에는 관련법 및 소비자 분쟁 해결 기준에 따라 심의가 진행 되며 특별한 경우에는 소비자 보호원을 통한 심사를 진행 할 수 있습니다. 따라서 세탁시에는 반드시 아래 내용을 참고 부탁 드립니다.
                </p>
                <span className="font-bold">의류</span>
                면 류의 제품은 부분 세탁을 할 경우, 마찰이 발생하여 색 빠짐 현상이 있을 수 있으니 이 점 유의 바랍니다.<br/>
                땀을 많이 흘렸을 경우 즉시 세탁 하십시오.<br/>
                세탁시 뜨거운 물은 피하며, 손세탁 또는 기계세탁시 단일 세탁 후, 탈수 시간을 짧게 하여 주십시오.<br/>
                흰옷과 유색옷은 이염될수 있으므로 반드시 구분하여 세탁 하십시오.<br/>
                프린팅이 들어간 제품은 프린팅에 손상이 가지 않도록 뒤집어 세탁 하십시오.<br/>
                염소 표백제 및 강력효소제는 절대 사용하지 마십시오.<br/>
                세제를 먼저 물에 풀어 충분히 용해시킨후 세탁하십시오.<br/>
                면이 함유된 제품은 세탁후 약간의 수축현상이 생길수있으니 유의 바랍니다.<br/>
                물에 오래 담가 두거나, 세탁후 그대로 놓아두면 탈색이나 이염이 될수있으니 세탁 후 바로 탈수를 하여 주십시오.<br/>
                울 제품의 경우 물세탁을 삼가하며 반드시 드라이크리닝을 하십시오.<br/>
                지퍼나 단추가 있는 제품의 경우 잠근 상태에서 세탁 하십시오.
              </p>
              <br/>
              *가먼트 다이(garment dye)의 경우, 완성된 제품에 추가로 염색을 진행하는 공법을 의미하며, 착용하면서 발생하는 자연스러운 물 빠짐이 있습니다.<br/>
              이로 인한 제품 교환, 환불은 불가하며, 오염이 발생했을 경우 부분 세탁이 아닌 전체 세탁으로 진행 부탁드리며, 흰옷이나 밝은 계열의 옷과 착용 시 이염이 발생할 수 있으니, 세탁 후 착용 바랍니다.
              <br/>
              <p className="flex flex-col ">
                <span className="font-bold">신발</span>
                *신발 제품의 경우 착화 시 반드시 실내에서 신어보아야 하며, 발등 주름 및, 뒤꿈치 구김, 창 바닥이 손상이 될 경우 교환, 환불의 사유가 될 수 없는 점 참고 바랍니다.<br/>
                건조시킬 때에는 햇볕이 잘 들지 않는 그늘진 곳에서 말려주십시오.<br/>
                기름기가 있는 장소에서의 사용은 피하십시오.<br/>
                표면의 오염 발생시 비눗물을 적신 천으로 오염 부분을 닦아주시고, 구두약, 신발 보호제를 사용하지 마십시오.<br/>
                세탁시 가급적 세탁 전문 업체에 문의 하십시오.<br/>
                신발 뒷꿈치를 꺾어 신지 마십시오.
              </p>

              <p className="flex flex-col ">
                <span className="font-bold">가죽</span>
                젖었을 경우 직사일광이나 열로 건조시키지 마십시오.<br/>
                오염시 부드러운 솔로 닦고 가죽 전문 크리너를 사용 하십시오.<br/>
                보존시 적정한 온도와 습도에서 보관하십시오.<br/>
                세탁시 가죽 전문 세탁 업체에 문의 바랍니다.<br/>
                불꽃 접근시 불길이 옮겨 붙을 가능성이 있으니 취급에 주의하여 주십시오.
              </p>
            </div>
          </div>
        </div>
      </>
  );
};
